<button class="pill" ds-pill [selected]="active()" [variant]="variantStrong" [size]="sizeMedium" (click)="onClick()">{{ label() }}</button>
